var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.saving),expression:"saving"}],attrs:{"id":"app"}},[_c('scheduler',{ref:"scheduler",attrs:{"id":"dp","config":_vm.initConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }